import script from "./PageHero.vue?vue&type=script&setup=true&lang=ts"
export * from "./PageHero.vue?vue&type=script&setup=true&lang=ts"

import "./PageHero.vue?vue&type=style&index=0&id=4db95813&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4db95813"]])

export default __exports__